import React from 'react';
import { PromptVersion } from '@/hooks/usePrompt';
import { useLanguage } from '@/contexts';

interface VersionInfoProps {
  latestVersion: PromptVersion;
}

const VersionInfo: React.FC<VersionInfoProps> = ({ latestVersion }) => {
  const { t } = useLanguage();

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-blue-900">{t("latestVersionInfo")}</h4>
        <span className="text-xs text-blue-600">{t("version")} {latestVersion.version_number}</span>
      </div>
      {latestVersion.change_notes && (
        <p className="text-sm text-blue-800 mb-2">
          <strong>{t("changes")}:</strong> {latestVersion.change_notes}
        </p>
      )}
      <p className="text-xs text-blue-600">
        {t("updated")} {new Date(latestVersion.created_at).toLocaleDateString()} {t("by")} {latestVersion.created_by_name}
      </p>
    </div>
  );
};

export default VersionInfo;
